module.exports = __webpack_public_path__ + "img/quest_icon_0038_wing.ae98a382.png";